import type { ComponentType } from 'react';
import type { Block } from './types';

export interface BlockRendererProps {
  block: Block;
}

type BlockRendererComponent = ComponentType<BlockRendererProps>;

const registry = new Map<string, BlockRendererComponent>();

export function registerBlockRenderer(blockType: string, component: BlockRendererComponent): void {
  registry.set(blockType, component);
}

export function getBlockRenderer(blockType: string): BlockRendererComponent | undefined {
  return registry.get(blockType);
}
